export const API_REQUEST_DELIVERY = `/api/request_delivery`;
export const API_CANCEL_ORDER = `/api/cancel_order`;
export const API_NOTIFICATION = (companyId) =>
  `/api/${companyId}/push-notifications`;
export const API_SEND_NOTIFICATION = `/api/send_notification`;
export const API_CLOUD_WATCH = `/api/stream_logs`;
export const API_GET_SHOP_STRIPE_BALANCE = `/api/get_shop_balances`;
export const API_TO_TAKEAWAY = `/api/accept_order`;
export const API_VALIDATE_ORDER = '/api/validate_order_driver';
export const API_PREPARE_ORDER = '/api/prepare_order';
export const API_CREATE_CUSTOM_AND_EXTERNAL_ACCOUNT =
  '/api/create_custom_and_external_account';
export const API_GET_CUSTOM_VERIFICATION_LINK =
  '/api/stripe/custom/verification_link';
export const API_CUSTOM_ACCOUNT = '/api/stripe/custom/account';
export const API_UPDATE_CLOSED_SHOP = '/api/shop/closed';
export const API_SEND_ORDER_TO_DRIVERS = '/api/send_order_drivers';
export const API_ORDER_PREPARING_UPDATE = '/api/order/preparing/update';
export const API_UPDATE_DRIVER_ACTIVATION = '/api/drivers/activation';
export const API_GET_CLOSED_DRIVERS = '/api/get_drivers';
export const API_REFUND_PAYMENT = (companyId, shopId) => `/api/${companyId}/shops/${shopId}/payments/refund`;
export const API_CREATE_OPTION_ITEM = (companyId, shopId, optionKey) =>
  `/api/${companyId}/shops/${shopId}/options/${optionKey}/items`;
export const API_CREATE_OPTION = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/options`;
export const API_UPDATE_OPTION = (companyId, shopId, optionKey) =>
  `${API_CREATE_OPTION(companyId, shopId)}/${optionKey}`;
export const API_UPDATE_OPTION_ITEM = (companyId, shopId, optionKey, itemKey) =>
  `/api/${companyId}/shops/${shopId}/options/${optionKey}/items/${itemKey}`;
export const API_DELETE_OPTION = '/api/option/delete';
export const API_CREATE_PROMOTION = '/api/promotion/update';
export const API_GENERATE_ACCESS_TOKEN_HUBRISE = '/api/hubrise/token';
export const API_CREATE_SECTION = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/sections`;
export const API_UPDATE_SECTION = (companyId, shopId, sectionKey) =>
  `/api/${companyId}/shops/${shopId}/sections/${sectionKey}`;
export const API_CREATE_PRODUCT = (companyId, shopId, sectionKey) =>
  `/api/${companyId}/shops/${shopId}/sections/${sectionKey}/products`;
export const API_UPDATE_PRODUCT = (companyId, shopId, sectionKey, productKey) =>
  `/api/${companyId}/shops/${shopId}/sections/${sectionKey}/products/${productKey}`;
export const API_DELETE_PRODUCT = '/api/product/delete';
export const API_SYNCHRONIZE_MENU_HUBRISE = '/api/hubrise/menu';
export const API_UPLOAD_IMAGE = '/api/image/upload';
export const API_GET_CUSTOMER_ORDERS = '/api/customer/orders';
export const API_DISCONNECT_HUBRISE = '/api/hubrise/disconnect';
export const API_GET_SALES_SHOP = '/api/shop/sales';
export const API_GET_BILLING_SHOP = '/api/shop/billing';
export const API_GET_COMPLETED_ORDERS = '/api/orders/completed';
export const API_SYNCHRONIZE_MENU = '/api/menu/synchronize';
export const GET_PAYOUT_DETAILS = '/api/get_payout_details';
export const API_GET_DRIVER_BILLINGS = '/api/fleet/drivers-billings';
export const API_GET_CUSTOM_STRIPE_API_KEY = (companyId) =>
  `/api/${companyId}/stripe/custom/api-keys`;
export const API_LUNCH_DELIVERY = (companyId, chargeId, customerId) =>
  `/api/${companyId}/users/${customerId}/orders/${chargeId}/launch-delivery`;
export const API_READY_TO_TAKEAWAY = (companyId, chargeId, customerId) =>
  `/api/${companyId}/users/${customerId}/orders/${chargeId}/ready-to-takeaway`;
export const API_ACCEPT_DELIVERY = (companyId, chargeId, customerId) =>
  `/api/${companyId}/users/${customerId}/orders/${chargeId}/accept-delivery`;
export const API_UPDATE_NOTIFICATION = (companyId, pushNotificationId) =>
  `/api/${companyId}/push-notifications/${pushNotificationId}`;
export const API_UPDATE_PROMO = (companyId, shopId, promoCode) =>
  `/api/${companyId}/shops/${shopId}/promotions/${promoCode}`;
export const API_GET_PLACE_AUTOCOMPLETE = (companyId) =>
  `/api/${companyId}/google/places/autocomplete`;
export const API_GET_PLACE_DETAIL = (companyId, placeId) =>
  `/api/${companyId}/google/places/${placeId}/details`;
export const API_GET_GEOCODE_FROM_ADDRESS = (companyId) =>
  `/api/${companyId}/google/geocode/from-address`;
export const API_PROXY_GET_FILE = '/api/resource/file';
export const API_UPDATE_AUTOACCEPT = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/configuration/auto-accept`;
export const API_UPDATE_EXPIRED_PROMOTION = (companyId, shopId, promotionKey) =>
  `/api/${companyId}/shops/${shopId}/promotions/${promotionKey}/expired`;
export const API_UPDATE_SHOP_SETTINGS = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/shop-settings`;
export const API_UPDATE_USER_SERVICE_PRICE = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/configuration/delivery/user-service-price`;
export const API_UPDATE_DRIVER_SERVICE_PRICE = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/configuration/delivery/driver-service-price`;
export const API_DELETE_USER_SERVICE_PRICE = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/configuration/delivery/user-service-price`;
export const API_UPDATE_SHOP_PAYMENT_AND_SALES_TYPE = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/configuration/payment-and-sales-type`;
export const API_DELETE_OPEN_CITIES = (companyId, shopId, cityName) =>
  `/api/${companyId}/shops/${shopId}/open-cities/${cityName}`;
export const API_DELETE_DISTRICTS = (
  companyId,
  shopId,
  cityName,
  districtName,
) =>
  `/api/${companyId}/shops/${shopId}/open-cities/${cityName}/districts/${districtName}`;
export const API_DELETE_SUB_LOCALITIES = (
  companyId,
  shopId,
  cityName,
  subLocalityName,
) =>
  `/api/${companyId}/shops/${shopId}/open-cities/${cityName}/sub-localities/${subLocalityName}`;
export const API_UPDATE_CITY_NAME = (companyId, shopId, cityName) =>
  `/api/${companyId}/shops/${shopId}/open-cities/${cityName}`;
export const API_UPDATE_DELIVERY_ZONE_NAME = (
  companyId,
  shopId,
  deliveryZoneName,
) => `/api/${companyId}/shops/${shopId}/delivery-zones/${deliveryZoneName}`;
export const API_DELETE_DELIVERY_ZONE = (companyId, shopId, deliverZoneKey) =>
  `/api/${companyId}/shops/${shopId}/delivery-zones/${deliverZoneKey}`;
export const API_UPDATE_SUB_LOCALITIES = (companyId, shopId, cityName) =>
  `/api/${companyId}/shops/${shopId}/open-cities/${cityName}/sub-localities`;
export const API_UPDATE_DISTRICTS = (companyId, shopId, cityName) =>
  `/api/${companyId}/shops/${shopId}/open-cities/${cityName}/districts`;
export const API_UPDATE_SPECIAL_HOUR = (companyId, shopId, specialHourKey) =>
  `/api/${companyId}/shops/${shopId}/special-hours/${specialHourKey}`;
export const API_UPDATE_SHOP_LAUNCH = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/shop-launch`;
export const API_UPDATE_SHOP_HOURS = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/hours`;
export const API_UPDATE_SHOP_PRINTER = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/printer`;
export const API_DELETE_SPECIAL_HOUR = (companyId, shopId, specialHourKey) =>
  `/api/${companyId}/shops/${shopId}/special-hours/${specialHourKey}`;
export const API_GET_CONFIGURATION = (companyId) =>
  `/api/${companyId}/configuration`;
export const API_GET_ALL_MENUS = (companyId) => `/api/${companyId}/menus`;
export const API_UPDATE_MENU_POSITION = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/menu/positions`;
export const API_UPDATE_PRODUCT_STOCK = (
  companyId,
  shopId,
  sectionKey,
  productKey,
) =>
  `/api/${companyId}/shops/${shopId}/menu/sections/${sectionKey}/products/${productKey}/stock`;
export const API_UPDATE_SECTION_ACTIVATION = (companyId, shopId, sectionKey) =>
  `/api/${companyId}/shops/${shopId}/menu/sections/${sectionKey}/hidden`;
export const API_UPDATE_SECTIONS = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/menu/sections`;
export const API_GET_FIRST_BILLING = (companyId) =>
  `/api/${companyId}/billing/first`;
export const API_GET_LAST_BILLING = (companyId) =>
  `/api/${companyId}/billing/last`;
export const API_GET_CANCELED_ORDER = (companyId, userId, orderId) =>
  `/api/${companyId}/canceled-order/users/${userId}/orders/${orderId}`;
export const API_DELETE_SECTION = (companyId, shopId, sectionKey) =>
  `/api/${companyId}/menus/shops/${shopId}/sections/${sectionKey}`;
export const API_DELETE_SUPPORT = (companyId, userId, orderId) =>
  `/api/${companyId}/support/users/${userId}/orders/${orderId}`;
export const API_CREATE_PRINT_ORDER = (companyId, shopId, userId, orderId) =>
  `/api/${companyId}/print-orders/shops/${shopId}/users/${userId}/orders/${orderId}`;
export const API_GET_ONE_SHOP = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}`;
export const API_UPDATE_CONFIGURATION_ACTIVATION = (companyId) =>
  `/api/${companyId}/configuration/activation`;
export const API_UPDATE_DELIVERY_USER_SERVICE_PRICE = (companyId) =>
  `/api/${companyId}/configuration/delivery/user-service-price`;
export const API_UPDATE_DELIVERY_DRIVER_SERVICE_PRICE = (companyId) =>
  `/api/${companyId}/configuration/delivery/driver-service-price`;
export const API_UPDATE_WEBAPP_KEYWORDS = (companyId) =>
  `/api/${companyId}/configuration/webapp/keywords`;
export const API_UPDATE_WEBAPP_CART_PHRASE = (companyId) =>
  `/api/${companyId}/configuration/webapp/cart-phrase`;
export const API_UPDATE_DESIGN_WEB = (companyId) =>
  `/api/${companyId}/configuration/design-web`;
export const API_UPDATE_DESIGN_WEB_MOBILE = (companyId) =>
  `/api/${companyId}/configuration/design-web-mobile`;
export const API_UPDATE_DESIGN_MOBILE = (companyId) =>
  `/api/${companyId}/configuration/design-mobile`;
export const API_UPDATE_NEW_PRODUCTS = (companyId) =>
  `/api/${companyId}/configuration/new-products`;
export const API_UPDATE_CONFIGURATION_PAYMENT_AND_SALES_TYPE = (companyId) =>
  `/api/${companyId}/configuration/payment-and-sales-type`;
export const API_GET_ALL_USERS = (companyId) => `/api/${companyId}/users`;
export const API_UPDATE_ORDER_SETTINGS = (companyId) =>
  `/api/${companyId}/configuration/order/settings`;
export const API_DELETE_CONFIGURATION_USER_SERVICE_PRICE = (companyId) =>
  `/api/${companyId}/configuration/delivery/user-service-price`;
export const API_UPDATE_DRIVERS_PAYMENT_VALUES = (companyId, driverId) =>
  `/api/${companyId}/drivers/${driverId}/payment-values`;
export const API_GET_CREDENTIALS = () => `/api/firebase/credentials`;
export const API_GET_SHOP_USERS = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/users`;
export const API_GET_CONFIGURATION_SERVICE_PRICE = (companyId) =>
  `/api/${companyId}/configuration/service-price`;
export const API_GET_COMPANY_SHOP_IDS = (companyId) =>
  `/api/${companyId}/shop-ids`;
export const API_GET_ROLES_AND_PERMISSIONS = (companyId, userId) =>
  `/api/${companyId}/users/${userId}/roles`;
export const API_CREATE_CAMPAIGN_MARKETING = (companyId) =>
  `/api/${companyId}/marketing-campaign`;
export const API_GET_MARKETING_CAMPAIGNS = (companyId) =>
  `/api/${companyId}/marketing-campaigns`;
export const API_CANCEL_MARKETING_CAMPAIGN = (
  companyId,
  marketingCampaignKey,
) => `/api/${companyId}/marketing-campaigns/${marketingCampaignKey}/cancel`;
export const API_CANCEL_SHOP_MARKETING_CAMPAIGN = (
  companyId,
  shopId,
  marketingCampaignKey,
) => `/api/${companyId}/shops/${shopId}/marketing-campaigns/${marketingCampaignKey}/cancel`;
export const API_UPDATE_MARKETING_CAMPAIGN = (
  companyId,
  marketingCampaignKey,
) => `/api/${companyId}/marketing-campaigns/${marketingCampaignKey}`;
export const API_UPDATE_SHOP_MARKETING_CAMPAIGN = (
  companyId,
  shopId,
  marketingCampaignKey,
) => `/api/${companyId}/shops/${shopId}/marketing-campaigns/${marketingCampaignKey}`;
export const API_UPDATE_DELIVEROO_CGU = (companyId, shopId) =>
  `/api/${companyId}/shops/${shopId}/deliveroo/accept-cgu-terms`;
export const API_GET_DISHOP_MESSAGE = `/api/general-settings/dashboard/communication/informative`;
export const API_GET_HOTLINE_AVAILABILITY =
  '/api/general-settings/hotline-availability';
export const API_UPDATE_DELIVERY_REMINDER_TRIGGERED = (
  companyId,
  userId,
  orderId,
) =>
  `/api/${companyId}/users/${userId}/orders/${orderId}/deliveryReminderTriggered`;
export const API_GET_IP_ADDRESS = 'https://api.ipify.org?format=json';
export const API_UPDATE_DATE_PREPARATION_ENDEND = (
  companyId,
  userId,
  orderId,
) =>
  `/api/${companyId}/users/${userId}/orders/${orderId}/date-preparation-ended`;
export const API_GET_COMPANY_INVOICE = (companyId) => `/api/${companyId}/invoice`;
export const API_GET_SHOP_INVOICE = (companyId, shopId) => `/api/${companyId}/shops/${shopId}/invoice`;
export const API_GET_DEFAULT_PREP_TIME = `/api/general-settings/orders/default-preparation-time`
export const API_GET_SMS_CAMPAIGNS = (companyId) => `/api/${companyId}/sms-campaigns`;
export const API_GET_SMS_PACKS = (companyId) => `/api/${companyId}/credit-packs`;
export const API_GET_WALLET_CREDITS = (companyId) => `/api/${companyId}/wallet/credits`;
export const API_CREATE_CREDIT_PACK = (companyId) => `/api/${companyId}/credit-pack/buy`;
export const API_CREATE_SMS_CAMPAIGN = (companyId) => `/api/${companyId}/sms-campaigns`;
export const API_GET_MESSAGE_PRICE = (companyId) => `/api/${companyId}/service/message/price`;
export const API_GET_LIST_USERS = (companyId) => `/api/${companyId}/users/list/with-newsletter`;
export const GET_MARKETING_CAMPAIGN = (
  companyId,
  marketingCampaignKey,
) => `/api/${companyId}/marketing-campaigns/${marketingCampaignKey}`;
export const API_POST_INVOICE_EXPORT = (companyId) => `/api/${companyId}/invoice-export`;
export const API_GET_INVOICE_EXPORT_STATUS = (companyId, jobId) =>
  `/api/${companyId}/invoice-export/${jobId}/status`;
